import { ID, Logger } from "@kosmod/kit";
import { Shape } from "@kosmod/pancake";

export type ToolID = ID<"theatre:tool", true>;

export type ToolDefinition = {
  key: string,
  state: Shape,
};

export type ToolStateOf<T extends ToolDefinition> = { id: ToolID, type: T["key"] } & Shape.Type.Of<T["state"]>;

export const defineTool = <const T extends ToolDefinition>(definition: T) => {
  return definition;
}
